import React from "react";

const ProgressBar = (props) => {
  const sections = [
    "Course Name, Code, Credit Hours, and Teaching hours",
    "Course Description",
    "Core Issue",
    "Grand Challenges",
    "Big Ideas",
    "Core Concepts",
    "STEM English Routine",
    "Course Learning Outcomes",
    "Modules",
    "Basis for Student Evaluation By Type",
    "Weely Plan",
    "Teacher Notes",
    "Teaching Resources",
    "Suggested Class Readings & Resources",
    "Equipment/Materials/Software",
  ];
  const icons = props.progressA.split(",").map((val, ix) => {
    const key = "statSpan" + ix;
    return val == "1" ? (
      <span
        key={key}
        title={`${sections[ix]} - completed`}
        className="mt-1 d-flex flex-col card status-box status-box--green"
      ></span>
    ) : (
      <span
        key={key}
        title={`${sections[ix]} - not yet complete`}
        className="mt-1 d-flex flex-col card status-box status-box--red"
      ></span>
    );
  });

  return (
    <div className="d-flex flex-row justify-content-left">
      <label className="mr-2 font-weight-bold">Progress: </label>
      {icons}
    </div>
  );
};

export default ProgressBar;
